import clsx from 'clsx'
import { NavLink, Outlet } from 'react-router-dom'

import { ReactComponent as ResearcherSvg } from '../../../assets/svgs/researcher.svg'
import { ReactComponent as ClientSvg } from '../../../assets/svgs/client.svg'
import { ReactComponent as AssetSvg } from '../../../assets/svgs/asset.svg'
import { ReactComponent as AssetAnalystSvg } from '../../../assets/svgs/asset-analyst.svg'
import { ReactComponent as ExpertSvg } from '../../../assets/svgs/expert.svg'
import { ReactComponent as SettingsSvg } from '../../../assets/svgs/settings-secondary.svg'
import { useMediaQuery } from '../../../hooks/useMediaQuery'
import { Medias } from '../../../enumns/medias'
import { Can } from '../../../guards/GuardContext'

export const Registers = () => {
  const isMinScreenWidthLG = useMediaQuery(`(min-width: ${Medias.LG}px)`)

  return (
    <div className="relative p-6 lg:flex lg:my-8 lg:px-7 lg:py-8 lg:gap-11">
      <div>
        {isMinScreenWidthLG && (
          <aside className="lg:sticky lg:top-8">
            <nav className="flex flex-col ">
              <NavLink
                to="researcher"
                className={({ isActive }) =>
                  clsx(
                    'text-grey-700 w-52 font-medium h-14 flex px-4 rounded-2xl',
                    {
                      'bg-secondary-dark text-white font-bold  stroke-white':
                        isActive,
                      'stroke-grey-700': !isActive,
                    }
                  )
                }
              >
                <span className="flex items-center gap-4">
                  <ResearcherSvg />
                  Researcher
                </span>
              </NavLink>

              <NavLink
                to="client"
                className={({ isActive }) =>
                  clsx(
                    'text-grey-700 w-52 font-medium h-14 flex px-4 rounded-2xl',
                    {
                      'bg-secondary-dark text-white font-bold  stroke-white':
                        isActive,
                      'stroke-grey-700': !isActive,
                    }
                  )
                }
              >
                <span className="flex items-center gap-4">
                  <ClientSvg />
                  Cliente
                </span>
              </NavLink>

              <NavLink
                to="asset"
                className={({ isActive }) =>
                  clsx(
                    'text-grey-700 w-52 font-medium h-14 flex px-4 rounded-2xl',
                    {
                      'bg-secondary-dark text-white font-bold  stroke-white':
                        isActive,
                      'stroke-grey-700': !isActive,
                    }
                  )
                }
              >
                <span className="flex items-center gap-4">
                  <AssetSvg />
                  Asset
                </span>
              </NavLink>

              <NavLink
                to="asset-analyst"
                className={({ isActive }) =>
                  clsx(
                    'text-grey-700 w-52 font-medium h-14 flex px-4 rounded-2xl',
                    {
                      'bg-secondary-dark text-white font-bold  stroke-white':
                        isActive,
                      'stroke-grey-700': !isActive,
                    }
                  )
                }
              >
                <span className="flex items-center gap-4">
                  <AssetAnalystSvg />
                  Analista Asset
                </span>
              </NavLink>

              <NavLink
                to="expert"
                className={({ isActive }) =>
                  clsx(
                    'text-grey-700 w-52 font-medium h-14 flex px-4 rounded-2xl',
                    {
                      'bg-secondary-dark text-white font-bold  stroke-white':
                        isActive,
                      'stroke-grey-700': !isActive,
                    }
                  )
                }
              >
                <span className="flex items-center gap-4">
                  <ExpertSvg />
                  Expert
                </span>
              </NavLink>

              <Can I="read" a="Admin">
                <div className="bg-grey-200 h-[2px] my-3" />

                <NavLink
                  to="admin"
                  className={({ isActive }) =>
                    clsx(
                      'text-grey-700 w-52 font-medium h-14 flex px-4 rounded-2xl',
                      {
                        'bg-secondary-dark text-white font-bold  stroke-white':
                          isActive,
                        'stroke-grey-700': !isActive,
                      }
                    )
                  }
                >
                  <span className="flex items-center gap-4">
                    <SettingsSvg />
                    Administradores
                  </span>
                </NavLink>
              </Can>
            </nav>
          </aside>
        )}
      </div>

      <div className="lg:px-8 lg:shadow-lg lg:grow lg:rounded-2xl lg:py-9">
        <Outlet />
      </div>
    </div>
  )
}
